export const useEditorVisualRemaining = (remaining: () => number) => {
  const visual = ref(remaining() || 1)

  watch(remaining, (value) => {
    if (value > 0) visual.value = value
  })

  return readonly(visual)
}
